import PropTypes from 'prop-types';
import React from 'react';

const FemaleGender = ({ color, ...props }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_2379_6323)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5217 1.49992C10.972 1.49992 9.48564 2.13206 8.38978 3.25728C7.29391 4.3825 6.67826 5.90863 6.67826 7.49994C6.67826 9.09124 7.29391 10.6174 8.38978 11.7426C9.48564 12.8678 10.972 13.5 12.5217 13.5C14.0715 13.5 15.5578 12.8678 16.6537 11.7426C17.7496 10.6174 18.3652 9.09124 18.3652 7.49994C18.3652 5.90863 17.7496 4.3825 16.6537 3.25728C15.5578 2.13206 14.0715 1.49992 12.5217 1.49992ZM5.21739 7.49994C5.21741 6.04855 5.62756 4.62835 6.39811 3.41158C7.16865 2.1948 8.26648 1.23373 9.55845 0.64492C10.8504 0.0561102 12.281 -0.13514 13.6768 0.0943651C15.0725 0.32387 16.3734 0.964269 17.4217 1.93789C18.47 2.91152 19.2206 4.17654 19.5826 5.57954C19.9445 6.98253 19.9022 8.46322 19.4608 9.84203C19.0194 11.2208 18.1979 12.4385 17.0959 13.3474C15.9938 14.2563 14.6586 14.8173 13.2522 14.9625V18H16.1739C16.3676 18 16.5534 18.079 16.6904 18.2196C16.8274 18.3603 16.9043 18.5511 16.9043 18.75C16.9043 18.9489 16.8274 19.1397 16.6904 19.2803C16.5534 19.421 16.3676 19.5 16.1739 19.5H13.2522V23.25C13.2522 23.4489 13.1752 23.6397 13.0382 23.7803C12.9013 23.921 12.7155 24 12.5217 24C12.328 24 12.1422 23.921 12.0052 23.7803C11.8683 23.6397 11.7913 23.4489 11.7913 23.25V19.5H8.86957C8.67584 19.5 8.49005 19.421 8.35307 19.2803C8.21609 19.1397 8.13913 18.9489 8.13913 18.75C8.13913 18.5511 8.21609 18.3603 8.35307 18.2196C8.49005 18.079 8.67584 18 8.86957 18H11.7913V14.9625C9.98959 14.7765 8.31937 13.9101 7.10466 12.5312C5.88995 11.1523 5.21737 9.35924 5.21739 7.49994Z"
        fill={color ?? '#224251'}
      />
    </g>
    <defs>
      <clipPath id="clip0_2379_6323">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

FemaleGender.propTypes = {
  color: PropTypes.string
};

export default FemaleGender;
